var DOM = {
		data: "#wpData",
		queries: ".js-query-filter",
		page: {
			el: "#js-page",
			type: {
				archive: ".ui-pg--archive",
				page: ".ui-pg--page",
				single: ".ui-pg--single",
			},
		},
		btn: {
			mastScroll: "#js-mast-next",
			menuOpen: ".js-menuOpen",
			menuClose: ".js-menuClose",
			loadmore: "#js-loadmore",
			loadprev: "#js-loadprev",
			infinscroll: "#js-infinscroll",
			searchTogg: ".js-search",
		},
		ui: {
			navbar: "#js-ui-navbar",
			footer: "#js-ui-footer",
			gridItem: ".js-gridItem",
			mnuPanel: "#js-menuPanel",
			searchPanel: "#js-searchbar",
			filters: ".js-filter",
			overlay: "#js-overlay",
			slideshow: ".js-slideshow",
		},
		archives: {
			postGird: "#posts-grid",
			pageLimit: ".js-pg-limit",
			postFilter: ".js-query-filter",
			catFilter: "#js-filter-category_name",
			yearFilters: "#js-filter-years",
			teamFilters: "#js-filter-team_group",
			teamItems: ".js-teamItem",
			viewTog: "#js-proj-togg",
		},
		filtersBar: {
			mdl: "#js-filters-mdl",
			apply: "#js-filters-apply",
			clear: "#js-filters-clear",
			viewTogg: "#js-portfolio-togg",
			mapFind: "#js-map-find",
			location_prime_filter: "#js-filter-location_prime",
			location_prime_group: "grp-location_prime",
			service_filter: "#js-filter-service",
			service_group: "grp-service",
			sector_filter: "#js-filter-sector",
			sector_group: "grp-sector",
			tags: "#js-filter-tags",
			liveLoader: "#js-filters-liveLoader",
			scroll: "#js-filters-scroll",
		},
		maps: {
			el: ".js-map",
			markers: ".js-map-marker",
			loader: "#js-map-loader",
			portfolio: "#js-map-portfolio",
		},
		video: { auto: ".js-autoVid" },
		modal: {
			ele: "#js-modal-panel",
			open: '[target="_modal"]',
			close: ".js-modal-close",
			content: "#js-modal-content",
			filters: {
				ele: "#js-modal-filters",
				open: '[target="_modal-filters"]',
				content: "#js-modal-filters-content",
			},
			source: ".js-modal-src",
			browse: ".ui-modal__browse",
			next: "#js-modal-next",
			prev: "#js-modal-prev",
		},
	},
	EVENTS = {
		PAGE: { READY: "PAGEREADY" },
		WINDOW: {
			RESIZE: "WINDOWRESIZE",
			BLUR: "WINDOWBLUR",
			FOCUS: "WINDOWFOCUS",
			SCROLL: "WINDOWSCROLL",
		},
		FILTERS: {
			CHANGE: "FILTERSCHANGE",
			CLEAR: "FILTERSCLEAR",
			DISABLE: "FILTERDISABLE",
			ENABLE: "FILETRENABLE",
		},
		MAP: { NEWLOCATION: "MAPNEWLOCATION", RESET: "MAPRESET" },
		API: { LOAD: "APILOAD", FAILED: "APIFAILED" },
	};
// console.log(EVENTS);

